import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  SxProps,
  useTheme,
} from "@mui/material";
import { EStatus } from "../Home/HeaderFilter";

type Props = {
  label: string;
  items: TQ3DSelectItem[];
  value: string;
  setValue: (s: string) => void;
  height?: string;
  width?: string;
  maxWidth?: string;
  sx?: SxProps;
  MenuProps?: {
    sx?: SxProps;
  };
  disabled?: boolean;
};

export type TQ3DSelectItem = { value: string; label: string };

export const Q3DSelect = (props: Props) => {
  const theme = useTheme();
  return (
    <FormControl>
      <InputLabel
        sx={{
          color: theme.palette.base.label,
        }}
      >
        {props.label}
      </InputLabel>
      <Select
        label={props.label}
        displayEmpty
        onChange={(e) => props.setValue(e.target.value as EStatus)}
        value={props.value}
        sx={{
          height: props.height ? props.height : "40px",
          width: props.width,
          borderRadius: "0px",
          minWidth: "50px",
          maxWidth: props.maxWidth ? props.maxWidth : "200px",
          color: theme.palette.base.contrast,
          ...props.sx,
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              width: props.width,
              maxWidth: props.maxWidth ? props.maxWidth : "200px",
              ...props.MenuProps?.sx,
            },
          },
        }}
        disabled={props.disabled}
      >
        {props.items.map((item, index) => (
          <MenuItem
            key={index}
            value={item.value}
            sx={{ whiteSpace: "break-spaces" }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
